import { field, relation } from '@nozbe/watermelondb/decorators';
import { WISHLIST_ITEMS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class CartItems extends Model {
    static table = WISHLIST_ITEMS_SCHEMA

    static associations = {
        wishlist: { type: 'belongs_to', key: 'wishlist_id' },
    }

    @field('product_id') product_id;
    @field('variant_id') variant_id;

    @relation('wishlist', 'wishlist_id') wishlist;
};